export default "__VITE_ASSET__C0RN9NlT__"